import React, { useState, useEffect, useContext } from 'react'
import useMedia from "use-media";
import { useTranslation } from 'react-i18next';
import '../language/i18n'

import { mainContext } from './MainContext';
import SeoHeadTag from '../common/seo/SeoHeadTag';
import Container from './parts/container/Container';
import Footer from './parts/footer/Footer';
import ChangeLanguage from './parts/lang/ChangeLanguage';


function Main() {
  const [isLangLoading, setIsLangLoading] = useState(true);

  // PC/SP判定
  const isWide = useMedia('(min-width: 768px)');

  // 言語設定(en/ja)
  const [langCode, setLangCode] = useState(null);
  const { t, i18n } = useTranslation();

  const [isBottom, setIsBottom] = useState(false);
  const [footerWrapHeight, setFooterWrapHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);


  // 初回言語設定
  useEffect(() => {
    (async() => {
      if(langCode == null) {
        // 初回言語設定
        try {
          // ローディング
          setIsLangLoading(true);

          const response = await fetch("https://ipapi.co/json/");
          const data = await response.json();

          if(data && data.languages) {
            if(data.languages.includes('en')) {
              // 英語の場合
              setLangCode('en');
            } else if(data.languages.includes('ja')) {
              // 日本の場合
              setLangCode('ja');
            } else if(data.languages.includes('zh')) {
              // 中国の場合
              setLangCode('zh-CN');
            } else if(data.languages.includes('ko')) {
              // 韓国の場合
              setLangCode('ko');
            } else {
              // デフォルト：日本にする
              setLangCode('ja');
            }
          } else {
            // デフォルト：日本語にする
            setLangCode('ja');
          }

        } catch(err) {
          // デフォルト：日本語にする
          setLangCode('ja');
        } finally {
          // ローディング終了
          setIsLangLoading(false);
        }

      } else {
        // 表示言語設定
        switch(langCode) {
          case 'en':
            // 英語
            i18n.changeLanguage('en');
            break;
          case 'ja':
            // 日本語
            i18n.changeLanguage('ja');
            break;
          case 'zh-CN':
            // 中語
            i18n.changeLanguage('zh-CN');
            break;
          case 'ko':
            // 韓国語
            i18n.changeLanguage('ko');
            break;
          default:
            // 日本語(デフォルト)
            i18n.changeLanguage('ja');
        }
      }
    })()
  }, [langCode])



  const contextValue = {
    isWide: isWide,
    langCode: langCode,
    setLangCode: setLangCode,
    footerWrapHeight: footerWrapHeight,
    setFooterWrapHeight: setFooterWrapHeight,
    isBottom: isBottom,
    setIsBottom: setIsBottom,
    footerHeight: footerHeight,
    setFooterHeight: setFooterHeight,
    getLink: 'https://line.me/R/ti/p/@055womqy',
  }


  return (
    <mainContext.Provider value={contextValue}>

      <SeoHeadTag />

      <Container />

      <Footer />

      <ChangeLanguage />

    </mainContext.Provider>
  );
}

export default Main;
